import styled, { css } from 'styled-components';

import { COLORS, Chip } from '@treelab/panda';

const Container = styled.div``;

const ChipSpacingMixin = css`
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }
`;

export const ChipAvatar = styled(Chip.Avatar)`
  ${ChipSpacingMixin}
`;

export const ChipPlain = styled(Chip.Plain)`
  ${ChipSpacingMixin}
`;
